// extracted by mini-css-extract-plugin
module.exports = {"s11lehqc":"s11lehqc"};